import React from "react";
import { Doughnut } from "react-chartjs-2";
import Typography from "@material-ui/core/Typography";
import * as Glob from "../../../../Globale";
import { Trad } from "../../../../components/";

interface ILimitChartProps {
    LeftLabel: string;
    UsedLabel: string;
    LeftVal: number;
    UsedVal: number;
    Title?: string;
}

export const _LimitChart: React.FC<ILimitChartProps> = ({ LeftLabel, UsedLabel, LeftVal, UsedVal, Title }) => {
    const leftBgColor = UsedVal >= LeftVal && UsedVal < LeftVal + (LeftVal * 20) / 100 ? Glob.ColoreStatic(0) : Glob.ColoreStaticA(1, 0.6);
    const data = {
        labels: [Trad.Trad(UsedLabel), Trad.Trad(LeftLabel)],
        datasets: [
            {
                data: [UsedVal, LeftVal],
                backgroundColor: [Glob.ColoreStaticA(2, 0.6), leftBgColor]
            }
        ]
    };

    return (
        <>
            {Title && <Typography variant="subtitle2">{Trad.Trad(Title)}</Typography>}
            <Doughnut data={data} />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Charts/LimitChart.tsx